export default "__VITE_ASSET__B5o0GRfp__"